<div class="autocomplete-container">
    <div class="search-box-container" *ngIf="showSearch">
        <input type="text" class="search-box" [(ngModel)]="searchText" (ngModelChange)="filterItems($event)" placeholder="Search">
        <img height="17" width="17" class="search-icon" [src]="'search.svg' | assetImageUrl">
    </div>
    <div  class="options-container" *ngIf="_displayParameter === ''">
        <ng-container>
            <div class="option" *ngFor="let item of dropdownList" (click)="onSelectOption(item)">
                <span appTooltip="{{item}}" [tooltipPosition]="'top'"
                [tooltipShow]="(item.length) > 24">
                    {{item | shorten: 24}}
                </span>
            </div>
        </ng-container>
        <ng-container *ngIf="dropdownList.length === 0">
            <div class="option no-data">
                No Data
            </div>
        </ng-container>
        
    </div>

    <div class="options-container" *ngIf="_displayParameter !== ''" >
        <ng-container *ngIf="dropdownList.length > 0">
            <div class="option" *ngFor="let item of dropdownList" (click)="onSelectOption(item)">
                <span appTooltip="{{item[_displayParameter]}}" [tooltipPosition]="'top'"
                [tooltipShow]="(item[_displayParameter].length) > 24">
                    {{item[_displayParameter] | shorten: 24}}
                </span>
            </div>

        </ng-container>

        <ng-container *ngIf="dropdownList.length === 0">
            <div class="option no-data">
                No Data
            </div>
        </ng-container>
        
    </div>
    
</div>